













import {Vue, Component, Prop} from 'vue-property-decorator';
import Application from "@/state/Application";
import PayrollService from "@/services/payroll/PayrollService";
import {processError} from "@/utils/ComponentUtils";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import {prettyEnum} from "@/utils/StringUtils";
import PaystubReportView from "@/components/payroll/reports/paystub/PaystubReportView.vue";
import PatriotPaystubView from "@/components/payroll/reports/paystub/PatriotPaystubView.vue";
import Notifications from "@/state/Notifications";
import moment from "moment/moment";
import {PayrollReport} from "@/components/payroll/business/employments/employee/PayrollReport";
import PayrollFileDTO from "@/dto/payroll/PayrollFileDTO";
import {Paystub} from "@/dto/payroll/PayrollDTO";

@Component({
	components: {PatriotPaystubView, PaystubReportView}
})
export default class PaystubReport extends Vue {

	@Prop()
	private report!: PayrollFileDTO | Paystub

	private download() {
		this.$docUtils.download(this.report.fileMeta.id)
	}

	private voidPayroll() {
		Application.startLoading()
		PayrollService.voidPayroll((this.report as Paystub).payrollId).then(
			() => {
				Notifications.success(`The paystub from ${moment(this.report.reportStart).format("MM/dd/yyyy")} to ${moment(this.report.reportEnd).format("MM/dd/yyyy")} has been successfully deleted`)
				this.$emit('void', this.report.id)
				Application.stopLoading();
			},
			err => processError(err, this)
		)
	}

	private void() {
		if (this.report.generatedBy == 'SUBLIME') {
			this.$modal.show(
				DeleteConfirmation,
				{
					targetName: prettyEnum(this.report.reportType),
					operationName: "void",
					onDelete: () => this.voidPayroll()
				}
			)
		} else {
			this.$modal.show(
				DeleteConfirmation,
				{
					targetName: prettyEnum(this.report.reportType),
					onDelete: () => {
						Application.startLoading()
						PayrollService.deleteDocument(this.report.id!, 'PAYROLL_FILE').then(
							() => {
								Notifications.success(`The paystub has been successfully deleted`)
								this.$emit("delete", this.report.id)
								Application.stopLoading()
							},
							err => processError(err, this)
						)
					}
				}
			)
		}
	}
}
